import userSharedFormsValidator from './userSharedFormsValidator';

class PasswordMatchValidator {

    validatePasswordBase(password) {

        const validation = userSharedFormsValidator.validateGenericRequiredField(password);

        const passwordValidationMessage = validation.errors.first('field');

        return {
            validation: validation,
            passwordValidationMessage: passwordValidationMessage
        };
    }

    validatePassword(password) {

        const validation = userSharedFormsValidator.validatePassword(password);

        const passwordValidationMessage = validation.errors.all('password').password;

        return {
            validation: validation,
            passwordValidationMessage: passwordValidationMessage
        };
    }

    validateMatchPassword(password, confirmedPassword) {

        const validation = userSharedFormsValidator.validateMatchPassword(password, confirmedPassword);

        const passwordValidationMessage = validation.errors.first('password');

        return {
            validation: validation,
            passwordValidationMessage: passwordValidationMessage
        };
    }
}

export default new PasswordMatchValidator();


// WEBPACK FOOTER //
// ./src/services/validations/passwordMatchValidator.js